import { format, getTime, formatDistanceToNow } from 'date-fns';

// ----------------------------------------------------------------------

export function fDate(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy';

  return date ? format(new Date(date), fm) : '';
}

export function fDateTime(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy p';

  return date ? format(new Date(date), fm) : '';
}

export function fTimestamp(date) {
  return date ? getTime(new Date(date)) : '';
}

export function fToNow(date) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
      })
    : '';
}

export const secondsToGhms = (seconds) => {
    if (seconds < 0) seconds = 0;

    const days     = Math.floor(seconds / 86400);
    const hours    = Math.floor((seconds % 86400) / 3600);
    const minutes  = Math.floor((seconds % 3600) / 60);
    const secondsLeft = seconds % 60;

    let parts = [];

    if (days > 0)     parts.push(`${days}g`);
    if (hours > 0)    parts.push(`${hours}h`);
    if (minutes > 0)  parts.push(`${minutes}m`);
    if (secondsLeft > 0 || parts.length === 0) parts.push(`${secondsLeft}s`);

    return parts.join(' ');
}

export const formatDate = (dbDate, slice = false) => {
    if (!dbDate) return '';

    let dateToParse = dbDate;
    // Se la stringa non specifica un fuso orario (formato DB standard), forziamo UTC
    if (typeof dbDate === 'string' && !dbDate.includes('T') && !dbDate.includes('Z') && !dbDate.includes('+')) {
        dateToParse = `${dbDate.replace(' ', 'T')}Z`;
    }

    const localeDate = new Date(dateToParse).toLocaleString();
    return !!slice ? localeDate.split(',')[0] : localeDate;
};

export const formatDate2 = (dbDate, slice = false) => {
    const localeDate = new Date(dbDate).toLocaleString();
    return !!slice ? localeDate.split(',')[0] : localeDate;
};

export const dateToYYYYMMDD = (dbDate) => {
    const d = new Date(dbDate);
    return d.toISOString().slice(0, 10);
};

export const dateToYYYYMMDDWithTime = (dbDate) => {
  const d = new Date(dbDate);
  return d.toISOString();
};

export const onClickDate = (evt) => {
  //alert(evt.target.value);
  if (evt.target && typeof evt.target.showPicker === 'function') {
    evt.target.showPicker();
  }
};

export const labelFormatDate = 'Nella forma DD/MM/YYYY';
export const labelFormatDateTime = 'Nella forma DD/MM/YYYY HH:i:s';
